import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { Rights } from 'src/app/models/enums/rights';
import { IViewAccessibility } from 'src/app/models/interfaces/view-accessibility.interface';
import { IView } from 'src/app/models/interfaces/view.interface';
import { MemoryService } from 'src/app/services/memory.service';
import { ViewAccessibilityComponent } from '../view-accessibility/view-accessibility.component';
import { ViewDetailContext } from '../view-detail-context';
import { ViewFormComponent } from '../view-form/view-form.component';

@Component({
    selector: 'app-view-detail',
    templateUrl: './view-detail.component.html',
    styleUrls: ['./view-detail.component.scss'],
    imports: [MatTabsModule, ViewFormComponent, ViewAccessibilityComponent]
})
export class ViewDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public viewUpdated: EventEmitter<IView> = new EventEmitter();

    /**
     * Emis lorsque le formulaire d'accessibilité est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public accessibilitiesUpdated: EventEmitter<IViewAccessibility[]> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: ViewDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ViewDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ViewDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /** Indique s'il faut affiocher les accessibilité */
    public displayAccessibilities = true;

    constructor(private memoryService: MemoryService) {
        this.displayAccessibilities = !!this.memoryService.getConnectedUser().hasRight(Rights.ViewEdit);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param view: Infos de la vue modifiée.
     */
    public onViewUpdated(view: IView) {
        this.viewUpdated.emit(view);
    }

    /** Appellé lorsque des changements sur le formulaire "Accessibilité" sont sauvegardés.*/
    public onAccessibilitiesUpdated(accessibilities: IViewAccessibility[]) {
        this.accessibilitiesUpdated.emit(accessibilities);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param value:
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
